import { render } from "./LoaderVertical.vue?vue&type=template&id=671a9dca"
import script from "./LoaderVertical.vue?vue&type=script&lang=js"
export * from "./LoaderVertical.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__